import { render, staticRenderFns } from "./business-log.vue?vue&type=template&id=2f08969b"
import script from "./business-log.vue?vue&type=script&lang=js"
export * from "./business-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports